import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import { ChangeOfAccountant, ChangeOfAccountantForm } from "./accountantDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeOfAccountant>,
  data?: ChangeOfAccountant,
): ChangeOfAccountantForm {
  return new ChangeOfAccountantForm(dispatch, context, data);
}

export function handleEvent(form: ChangeOfAccountantForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function applyForm(form: ChangeOfAccountantForm): ChangeOfAccountant {
  return {
    type: DecisionType.accountant,
    name: form.selectedCompanyForAccountant?.name,
    email: form.emailModel.validatedValue,
    organisationNumber: form.selectedCompanyForAccountant?.organizationnumber,
    businessAddress1: form.selectedCompanyForAccountant?.address,
    businessAddress2: form.selectedCompanyForAccountant?.address2,
    businessCity: form.selectedCompanyForAccountant?.city,
    businessCountry: form.selectedCompanyForAccountant?.sourceCountry,
    businessZip: form.selectedCompanyForAccountant?.zip,
    previousAccountant: form.data?.previousAccountant,
  };
}

export function validate(form: ChangeOfAccountantForm): boolean {
  return form.validate();
}

export function isValid(form: ChangeOfAccountantForm): boolean {
  return form.isValid;
}

export const accountantHandler: DecisionTypeHandler<
  DecisionType.accountant,
  ChangeOfAccountant,
  ChangeOfAccountantForm
> = {
  type: DecisionType.accountant,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
